export class BaseClass {

    protected constructor() {}

    get className(): string {
        return (<any>this.constructor).name;
    }
}
